// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quote-xRvdnt{flex-direction:row;align-items:center;gap:4px;max-width:100%;margin-bottom:8px;display:inline-flex}.left-I2dAZ6{background:var(--Light-color-grey---grey-2,#c6c6cd);border-radius:3px;width:2px;height:14px}.content-yBHLM3{color:var(--Light-color-grey---grey-3,#a7a7b0);text-overflow:ellipsis;text-wrap:nowrap;font-size:12px;font-style:normal;font-weight:500;line-height:16px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quote": `quote-xRvdnt`,
	"left": `left-I2dAZ6`,
	"content": `content-yBHLM3`
};
export default ___CSS_LOADER_EXPORT___;
